interface ShowLegendButtonProps {
  showLegend?: boolean;
  setShowLegend: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ShowLegendButton = (props: ShowLegendButtonProps) => {
  const { setShowLegend, showLegend } = props;

  return (
    <button
      type="button"
      className="font-family-third color-[#0A0A0A] shrink-0 cursor-pointer border-none bg-none px-3 py-2 text-sm/[20px] font-medium underline transition-opacity duration-300 outline-none hover:opacity-70"
      onClick={() => setShowLegend((prev) => !prev)}
    >
      {showLegend ? "Hide legend" : "Show legend"}
    </button>
  );
};
